// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getIsNonPurchasable, xIsAuthenticated } from "@keller/App/Store/Selectors/GeneralSelectors";
import { xScreen } from "@keller/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

type OwnProps = WidgetProps;

export interface ProductDetailsCartActionsStyles {
    wrapper?: InjectableCss;
    qtyWrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss;
    addToListLinkWrapper?: InjectableCss;
}

export const productDetailsCartActionsStyles: ProductDetailsCartActionsStyles = {
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 8px;
            gap: 10px;
        `,
    },
    qtyWrapper: {
        css: css`
            flex: 0 0 92px;
        `,
    },
    addToCartWrapper: {
        css: css`
            flex: 0 0 145px;
            ${xScreen("lte", "xs")} {
                flex: 1 1 0;
            }
        `,
    },
    addToListLinkWrapper:{
        css: css`
            flex: 0 0 145px;
            margin-top: -16px;
        `,
    }
};

const styles = productDetailsCartActionsStyles;

const ProductDetailsCartActions: FC<OwnProps> = () => {
    const { isNonPurchasable, isAuthenticated } = useAppSelector(state => {
        return {
            isAuthenticated: xIsAuthenticated(state),
            isNonPurchasable: getIsNonPurchasable(state),
        };
    });

    
    if (!isAuthenticated) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            {/* Xng-changes: display ProductDetailsQuantityOrdered ,
             and limited ProductDetailsAddToListLink for web-only */}
            <StyledWrapper {...styles.qtyWrapper}>
                {createWidgetElement("ProductDetails/ProductDetailsQuantityOrdered", {
                    fields: {},
                })}
            </StyledWrapper>
            {isNonPurchasable && (
                <StyledWrapper {...styles.addToListLinkWrapper}>
                    {createWidgetElement("ProductDetails/ProductDetailsAddToListLink", {
                        fields: {},
                    })}
                </StyledWrapper>
            )}
            <StyledWrapper {...styles.addToCartWrapper}>
                {createWidgetElement("ProductDetails/ProductDetailsAddToCartButton", {
                    fields: {},
                })}
            </StyledWrapper>
            
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsCartActions,
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        displayName: "Product Details Cart Actions",
    },
};

export default widgetModule;
